import { render, staticRenderFns } from "./ExhibitionDetail.vue?vue&type=template&id=e4aeb6ae&scoped=true&"
import script from "./ExhibitionDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionDetail.vue?vue&type=style&index=0&id=e4aeb6ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aeb6ae",
  null
  
)

export default component.exports